import React from 'react';
import { motion } from 'framer-motion';
import { AlertCircle } from 'lucide-react';
import { useLanguage } from '../../context/LanguageContext';

export function WhyOffer() {
  const { t } = useLanguage();

  return (
    <section id="approach" className="py-24 md:py-32 bg-gradient-to-b from-slate-950 to-slate-900">
      <div className="max-w-4xl mx-auto px-6">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: '-100px' }}
          transition={{ duration: 0.6 }}
          className="text-center"
        >
          <h2 className="font-heading text-4xl md:text-5xl font-bold tracking-tight mb-4">
            {t('offer.title')}
          </h2>
          <p className="text-xl text-primary font-medium mb-8">
            {t('offer.subtitle')}
          </p>
          <p className="text-lg text-muted-foreground mb-10 max-w-2xl mx-auto">
            {t('offer.description')}
          </p>
          
          <motion.div
            initial={{ opacity: 0, scale: 0.95 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: 0.2 }}
            className="inline-flex items-center gap-3 px-6 py-4 rounded-xl bg-accent/10 border border-accent/30"
            data-testid="offer-highlight"
          >
            <AlertCircle className="text-accent shrink-0" size={24} />
            <span className="text-accent font-medium">{t('offer.highlight')}</span>
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
}
